import { useEffect, useState } from "react";
import { dbFetchHistory } from "../db";
import { ScoreBar } from "../components/ScoreBar";
import { yearLabel, MAX_ROUNDS } from "../mapUtils";

export default function HistoryScreen({ userId, onBack }) {
  const [games, setGames] = useState(null);
  const [expanded, setExpanded] = useState(null);

  useEffect(() => {
    dbFetchHistory(userId).then(setGames);
  }, [userId]);

  const scoreColor = (s) => s > 600 ? "#6fcf97" : s > 250 ? "#f0c040" : "#eb5757";

  return (
    <div style={{ background: "#0a0f16", minHeight: "100vh", fontFamily: "Georgia, serif", color: "#e8dcc8" }}>
      <div style={{ padding: "14px 20px", borderBottom: "1px solid #1a2530", display: "flex", alignItems: "center", gap: 16 }}>
        <span onClick={onBack} style={{ color: "#c9a84c", fontSize: 11, letterSpacing: 2, cursor: "pointer", opacity: 0.7 }}>← BACK</span>
        <span style={{ color: "#c9a84c", fontSize: 13, letterSpacing: 4 }}>GAME HISTORY</span>
      </div>

      <div style={{ maxWidth: 640, margin: "0 auto", padding: "20px 16px" }}>
        {games === null && (
          <div style={{ textAlign: "center", color: "#4a5a6a", letterSpacing: 3, fontSize: 11, marginTop: 60 }}>LOADING...</div>
        )}
        {games?.length === 0 && (
          <div style={{ textAlign: "center", color: "#4a5a6a", letterSpacing: 2, fontSize: 11, marginTop: 60 }}>No completed games yet.</div>
        )}
        {games?.map((g, i) => {
          const date = new Date(g.completed_at).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
          const isOpen = expanded === g.id;
          const sortedRounds = [...(g.rounds || [])].sort((a, b) => a.round_number - b.round_number);
          return (
            <div key={g.id} style={{
              border: "1px solid #1e2e3e", borderRadius: 8, marginBottom: 12, overflow: "hidden",
              background: "#0d1520",
            }}>
              <div onClick={() => setExpanded(isOpen ? null : g.id)} style={{
                padding: "14px 18px", cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center",
              }}>
                <div>
                  <div style={{ fontSize: 10, color: "#4a5a6a", letterSpacing: 2, marginBottom: 4 }}>{date}</div>
                  <div style={{ fontSize: 13, color: "#e8dcc8", letterSpacing: 1 }}>
                    Game #{games.length - i}
                  </div>
                  <ScoreBar score={g.total_score} max={MAX_ROUNDS * 1000} />
                </div>
                <div style={{ textAlign: "right" }}>
                  <div style={{ fontSize: 20, fontWeight: "bold", color: scoreColor(g.total_score / MAX_ROUNDS) }}>
                    {g.total_score}
                  </div>
                  <div style={{ fontSize: 10, color: "#4a5a6a", letterSpacing: 1 }}>/ {MAX_ROUNDS * 1000}</div>
                </div>
              </div>

              {isOpen && (
                <div style={{ borderTop: "1px solid #1a2530", padding: "12px 18px", display: "flex", flexDirection: "column", gap: 8 }}>
                  {sortedRounds.map(r => (
                    <div key={r.round_number} style={{ display: "flex", justifyContent: "space-between", fontSize: 12, color: "#9aa6b8" }}>
                      <span style={{ color: "#4a5a6a", minWidth: 60 }}>Round {r.round_number}</span>
                      <span>Actual <strong style={{ color: "#c9a84c" }}>{yearLabel(r.actual_year)}</strong></span>
                      <span>Guess <strong style={{ color: "#e8dcc8" }}>{yearLabel(r.guess_year)}</strong></span>
                      <strong style={{ color: scoreColor(r.score), minWidth: 36, textAlign: "right" }}>{r.score}</strong>
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
